export default Object.freeze([
	{ label: '$0', value: '0' },
	{ label: '$10', value: '10' },
	{ label: '$25', value: '25' },
	{ label: '$50', value: '50' },
	{ label: '$100', value: '100' },
	{ label: '$250', value: '250' },
	{ label: '$500', value: '500' },
]);
